/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_ORDERS_HISTORY_KEY } from './Table';
import { compareNumericString } from '../../../helpers/tableSort';

interface ITableWidths {
  exchange: number;
  type: number;
  baseAmount: number;
  fillBaseAmount: number;
  fillQuoteAmount: number;
  status: number;
  closedAt: number;
  priceAvg: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  exchange: 110,
  type: 90,
  baseAmount: 150,
  fillBaseAmount: 150,
  fillQuoteAmount: 150,
  status: 90,
  closedAt: 130,
  priceAvg: 130,
};

interface IUseTableDataProps {
  orders: any;
  base: string;
  quote: string;
}

const useTableData = ({ orders, base, quote }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_ORDERS_HISTORY_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => orders, [orders]);
  const columns = React.useMemo(
    () => [
      {
        id: 'closedAt',
        Header: 'Date closed',
        accessor: 'closed_at',
        width:
          tableColumnsWidth['closedAt'] ||
          tableWidthsDefaultState['closedAt'],
        sortType: compareNumericString(),
      },
      {
        id: 'exchange',
        Header: 'Exchange',
        accessor: 'exchange',
        disableSortBy: true,
        width:
          tableColumnsWidth['exchange'] || tableWidthsDefaultState['exchange'],
      },
      {
        id: 'baseAmount',
        Header: `Amount ${base}`,
        accessor: 'base_amount',
        width:
          tableColumnsWidth['baseAmount'] ||
          tableWidthsDefaultState['baseAmount'],
        sortType: compareNumericString(),
      },
      {
        id: 'fillBaseAmount',
        Header: `Filled ${base}`,
        accessor: 'fillBaseAmount',
        width:
          tableColumnsWidth['fillBaseAmount'] ||
          tableWidthsDefaultState['fillBaseAmount'],
        sortType: compareNumericString(),
      },
      {
        id: 'fillQuoteAmount',
        Header: `Filled ${quote}`,
        accessor: 'fillQuoteAmount',
        width:
          tableColumnsWidth['fillQuoteAmount'] ||
          tableWidthsDefaultState['fillQuoteAmount'],
        sortType: compareNumericString(),
      },
      {
        id: 'priceAvg',
        Header: 'Average price',
        accessor: 'priceAvg',
        width:
          tableColumnsWidth['priceAvg'] ||
          tableWidthsDefaultState['priceAvg'],
        sortType: compareNumericString(),
      },
      {
        id: 'type',
        Header: 'Order type',
        accessor: 'type',
        width: tableColumnsWidth['type'] || tableWidthsDefaultState['type'],
        sortType: compareNumericString(),
      },
      {
        id: 'status',
        Header: 'Status',
        accessor: 'status',
        sortType: compareNumericString(),
        width: tableColumnsWidth['status'] || tableWidthsDefaultState['status'],
      },
    ],
    [orders, base, quote]
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
